import React, { useEffect, useState, useRef } from 'react'
import { observer } from 'mobx-react';
import { useStore } from '../../../stores/Store';
import PreviewBrief from '../BriefPreview';
import { formatDate, processProjectsAndBriefs, processProfessionalsData, processProjectsData, fetchProsAndLeads } from '../../../utils/sharedFunctions.js';
import { Filter } from '../../../assets';
import './style.scss';
import { FilterRefined } from '../../../components';
const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`
const Credipple = `${process.env.REACT_APP_CDN_URL}/globalAssets/CredippleLogo.svg`;
const UserIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/people.png`;

var mobile = require('is-mobile');

const Overview = observer(() => {
    const store = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [Projects, setProjects] = useState([]);
    const [ViewProject, setViewProject] = useState(false);
    const [SelectedProject, setSelectedProject] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [Leads, setLeads] = useState([]);
    const [Professionals, setProfessionals] = useState([]);
    const [FilteredProjects, setFilteredProjects] = useState([]);
    const [isFilter, setIsFilter] = useState(false);
    const [isFilterCleared, setIsFilterCleared] = useState(true);
    const [FilterTerms, setFilterTerms] = useState([])
    const [AllUser, setAllser] = useState([])
    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            getBriefs();
        };
    }, []);

    const getBriefs = async () => {
        store.setLoading(true);
        try {
            // Fetch all project-related data
            const [confirmedBriefs, projPlans, projects, evaluation, vouchers, quotes, users] = await fetchProjectData();
            const prosAndLeads = await fetchProsAndLeads(users);
            // Process the fetched data to prepare projects
            const processedBriefs = processProjectsData(
                confirmedBriefs,
                projPlans,
                projects,
                evaluation,
                vouchers,
                quotes,
                prosAndLeads
            );
            // Combine all users (leads, professionals, clients) into a single array
            const allUsers = [...prosAndLeads.Leads, ...prosAndLeads.Pros, ...prosAndLeads.Clients];
            const validProjects = processProjectsAndBriefs(projects, processedBriefs, prosAndLeads.Leads, evaluation, prosAndLeads.Clients, projPlans);
            const professionals = processProfessionalsData(prosAndLeads.Pros, validProjects.processedProjects, processedBriefs);


            // Update state with fetched and processed data
            setAllser(allUsers ?? []);
            setLeads(prosAndLeads.Leads ?? []);
            setProfessionals(professionals ?? []);
            setProjects(processedBriefs ?? []);
        } catch (e) {
            // Log any errors that occur during the fetch or processing
            console.error('Error fetching projects:', e);
        } finally {
            store.setLoading(false);
        };
    };
    const fetchProjectData = async () => {
        try {
            return await Promise.all([
                store.getBriefs(),
                store.getProjectPlans(),
                store.getProjects(),
                store.getEvaluation(),
                store.getVouchers(),
                store.getQuote(),
                store.getUsers()
            ]);
        } catch (e) {
            console.error('Error fetching project data:', e);
            return [[], [], [], [], [], [], []];
        }
    };
    const backClicked = (back, isEdited) => {
        if (isEdited) {
            getBriefs();
        };
        setViewProject(back);
        forceUpdate();
    };
    const getSelectedProject = (id) => {
        let projects = isFilterCleared ? Projects : FilteredProjects;
        let selectedProject = projects.find(project => project._id === id);
        setSelectedProject(selectedProject);
        forceUpdate();
        setViewProject(true);
    };
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        forceUpdate();
    };
    const filteredProjects = (isFilterCleared ? Projects : FilteredProjects).filter(project => {
        const searchValue = searchTerm.toLowerCase();
        if (Object.keys(project).includes('briefTitle')) {
            if (project.briefTitle !== null || project.briefTitle !== undefined || project.briefTitle !== '') {

                return (project.briefTitle.toLowerCase().includes(searchValue));
            };
        };
    });
    function handleFilterClick() {
        setIsFilter(true);
    };
    function closeFilterMouseleave() {
        setIsFilter(false);
    };
    function closeCardClck() {
        setIsFilterCleared(true);
        closeFilterMouseleave();
        setFilterTerms([]);
    };
    function getSearchTerm(searchTerms) {
        let terms = FilterTerms;
        processProjectsFiltration(terms, searchTerms)
    };
    function handleFilterChange(items) {
        // Initialize an array to hold the projects to be filtered
        let projectsArr = [];

        // If no filter items are provided, use all projects; otherwise, use the filtered projects
        if (items.length === 0) {
            projectsArr = [...Projects];
        } else {
            projectsArr = [...FilteredProjects];
            projectsArr = [...Projects];
        };

        // If there are filter items, proceed to filter the projects
        if (items.length > 0) {
            // Filter projects based on whether any of the filter items match specific project properties
            let filteredProjs = projectsArr.filter((project) =>
                items.some((item) =>
                    (Array.isArray(project.typeOfProfessional) && project.typeOfProfessional.includes(item)) || // Match service category
                    item === project.contractType || // Match contract type
                    item === project.projectPlan?.[0]?.fulfillmentStage || // Match fulfillment stage
                    item === project.briefStatus || // Match brief status
                    item === project._id || // Match project ID
                    item === (Number(new Date(project.createdAt).getMonth()) + 1) || // Match project creation month
                    item === project.client?.firstName || // Match client first name
                    item === project.client?.lastName || // Match client last name
                    item === project.client?.company || // Match client company
                    item === project.client?.email || // Match client email
                    item === project.talentPartner?.firstName || // Match talent partner first name
                    item === project.talentPartner?.lastName || // Match talent partner last name
                    item === project.talentPartner?._id // Match talent partner ID
                )
            );

            // Filter projects further based on active lead filters
            const activeLeadFilters = items.filter(id => Leads.some(lead => lead._id === id));
            if (activeLeadFilters.length > 0) {
                filteredProjs = filteredProjs.filter(project => activeLeadFilters.includes(project.talentPartner?._id));
            }

            // Update the state to reflect the filtered projects and active filter terms
            setIsFilterCleared(false);
            setFilteredProjects(filteredProjs);
            setFilterTerms([...items]);
        } else {
            // If no filter items are provided, reset to show all projects
            setFilteredProjects([...Projects]);
            setIsFilterCleared(true);
            closeCardClck(); // Clear the filter UI
        }
    };
    function processProjectsFiltration(terms, newTerm) {
        let updatedTerms = [...terms];
        if (!updatedTerms.includes(newTerm)) {
            updatedTerms.push(newTerm);
        }

        // Filter projects based on updated terms
        let filteredProjs = Projects.filter((project) => {
            return updatedTerms.every((term) =>
                (Array.isArray(project.typeOfProfessional) && project.typeOfProfessional.includes(term)) || // Treat typeOfProfessional as an array
                term === project.contractType ||
                term === project.projectPlan?.[0]?.fulfillmentStage ||
                term === project.briefStatus ||
                term === project._id ||
                term === (Number(new Date(project.createdAt).getMonth()) + 1) ||
                term === project.client?.firstName ||
                term === project.client?.lastName ||
                term === project.client?.company ||
                term === project.client?.email ||
                term === project.talentPartner?.firstName ||
                term === project.talentPartner?.lastName ||
                term === project.talentPartner?._id
            );
        });
        // Update state with filtered projects and terms
        setIsFilterCleared(false);
        setFilteredProjects(filteredProjs);
        setFilterTerms(updatedTerms);
    };
    if (mobile()) {
        return (
            <div>

            </div>
        );
    } else {
        return (
            <div className='OverviewPage'>
                <div className='OverviewPageHeader'>
                    <p>Overview</p>
                    <img src={Credipple} alt='Credipple Logo' />
                </div>
                {(ViewProject) ?
                    <div style={{ width: '100%', height: '88%' }}>
                        <PreviewBrief project={SelectedProject} AllUsers={AllUser} navigateMainToPage={(e, isEdited) => backClicked(e, isEdited)} professionals={Professionals} leads={Leads} />
                    </div> :
                    <>
                        <div className='filterBriefsSection' >

                            <div className='search-bar-section' style={{ backgroundColor: '#ffffff', width: '25%', height: '50%' }}>
                                <img src={SearchIcon} alt='Search Icon' />
                                <input style={{ color: '#6D4194' }} placeholder='Search' value={searchTerm} onChange={handleSearchChange}></input>
                            </div>
                            <div onMouseEnter={handleFilterClick} className={FilterTerms.length === 0 ? 'filterContainer' : 'filterContainerAct'}>
                                <span className='filterspan' >
                                    <img onMouseEnter={handleFilterClick} src={Filter} alt='' className='filterimg' />
                                </span>
                                {FilterTerms.length === 0 ? null :
                                    <p style={{ color: 'white', paddingLeft: '5%' }}>Filters({FilterTerms.length})</p>
                                }
                            </div>
                            <div className='numofItems'>
                                <p className='spancular'>{filteredProjects.length}</p>
                            </div>
                        </div>

                        <div className='OverviewPageBody'>
                            {isFilter ? <FilterRefined Projects={FilterTerms.length === 0 ? Projects : filteredProjects} Leads={Leads} getFilterTerm={getSearchTerm} terms={FilterTerms} handleFilterChange={handleFilterChange} CloseFilterML={closeFilterMouseleave} CloseCardClck={closeCardClck} /> : null}
                            {filteredProjects.length > 0 && filteredProjects?.map((item, index) => {
                                let clientName = '';
                                let fulfillmentName = '';
                                let clientComp = '';
                                let professional = '';

                                if (Object.keys(item).length > 0 && Object.keys(item).includes('professionals')) {
                                    fulfillmentName = typeof (item.talentPartner) !== 'string' && item.talentPartner !== null && Object.keys(item.talentPartner).length > 0 ? `${item.talentPartner.firstName} ${item.talentPartner.lastName}` : '';
                                    professional = item.professionals.length > 0 ? `${item.professionals[0]?.firstName} ${item.professionals[0]?.lastName}` : '';
                                    if (typeof (item?.client) === 'object') {
                                        if (item?.client?.firstName && item?.client?.lastName) {
                                            clientName = `${item?.client?.firstName} ${item?.client?.lastName}`;
                                        } else {
                                            clientName = item?.client?.company || 'Not Assigned';
                                        }
                                        clientComp = item?.client?.email || item?.client?.website || 'Not Assigned';
                                    }
                                    return (
                                        <div className='availableBriefCard' key={index} onClick={() => getSelectedProject(item._id)}>
                                            <div className='availableBriefCardHeader'>
                                                <p style={{ margin: '0px' }}>{item.briefTitle}</p>
                                            </div>
                                            <div className='availableBriefBody'>
                                                <div className='profileSection'>
                                                    <div className='profileContainer'>
                                                        <div className='userProfile'>
                                                            <img alt='' src={UserIcon} style={{ width: '100%', height: '100%' }} />
                                                        </div>
                                                        <div className='clientDetails'>
                                                            <p style={{ margin: '0px' }} className='sectPlaceHolder'>{item.client?.firstName && item.client?.lastName ? `${item.client.firstName} ${item.client.lastName}` : clientName || 'Unknown client'}</p>
                                                            <p style={{ margin: '0px' }} className='sectValue'>{clientComp.length > 20 ? `${clientComp.substring(0, 20)}...` : clientComp || 'No client email'}</p>
                                                        </div>
                                                    </div>
                                                    <div className='otherMetricsSection'>
                                                        <p style={{ margin: '0px' }} className='sectPlaceHolder'>Start Date</p>
                                                        <p style={{ margin: '0px' }} className='sectValue'>{formatDate(item?.projectPlan[0]?.projStartDate) || 'No Date'}</p>
                                                        {/* {Array.isArray(item.projectPlan) && item.projectPlan.length > 0 ?
                                                            <p style={{ margin: '0px' }} className='sectValue'>{new Date(Object.keys(item?.projectPlan[0]).includes('projEndDate') ? item?.projectPlan[0]?.projEndDate : item?.projectPlan[0]?.projectEndDate).toISOString().split('T')[0] || 'No Date'}</p>
                                                            :
                                                            <p style={{ margin: '0px' }} className='sectValue'></p>
                                                        } */}
                                                    </div>
                                                </div>
                                                <div className='profileSection'>
                                                    <div className='otherMetricsSection'>
                                                        <p style={{ margin: '0px' }} className='sectPlaceHolder'>Category of service</p>
                                                        <p style={{ margin: '0px' }} className='sectValue'>{item?.serviceCategory?.length > 0 ? item?.serviceCategory[0] : 'Not Assigned'}</p>
                                                    </div>
                                                    <div className='otherMetricsSection'>
                                                        <p style={{ margin: '0px' }} className='sectPlaceHolder'>Fulfillment Lead</p>
                                                        <p style={{ margin: '0px' }} className='sectValue'>{fulfillmentName || 'Not Assigned'}</p>
                                                    </div>
                                                </div>
                                                <div className='profileSection'>
                                                    <div className='otherMetricsSection'>
                                                        <p style={{ margin: '0px' }} className='sectPlaceHolder'>Professionals</p>
                                                        <div className='availProfessionals'>
                                                            <div className='userProfile'>
                                                                <img alt='' src={UserIcon} style={{ width: '100%', height: '100%' }} />
                                                            </div>
                                                            <p>{typeof item.projectPlan[0].professional === 'object' ? `${item.projectPlan[0].professional.firstName || ''} ${item.projectPlan[0].professional.lastName || ''}` : 'Not Assigned'}</p>
                                                        </div>
                                                    </div>
                                                    <div className='otherMetricsSection'>
                                                        <p style={{ margin: '0px' }} className='sectPlaceHolder'>Fulfillment Stage</p>
                                                        <p style={{ margin: '0px' }} className='sectValue'>{Array.isArray(item.projectPlan) && item.projectPlan.length > 0 && Object.keys(item.projectPlan[0]).includes('fulfillmentStage') ? item.projectPlan[0].fulfillmentStage : 'Not Assigned'}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            })}
                        </div>
                    </>
                }
            </div>
        )
    }
})

export default Overview;